
// This file is now a wrapper that imports the refactored implementation
import { TranslationsManager as RefactoredTranslationsManager } from './translations/TranslationsManager';

export function TranslationsManager() {
  return <RefactoredTranslationsManager />;
}
